import React, { useMemo, useState } from "react";
import Footer from "../../Components/UI/Footer/Footer";
import Header from "../../Components/UI/Header/Header";
import { types } from "./ListTypes";
import "./ListView.scss";
import DamsSection from "./Sections/DamsSection";
import WeatherStation from "./Sections/WeatherStation";
import HydrometricSection from "./Sections/HydrometricSection";
import SynopticSection from "./Sections/SynopticSection";
import { mdiChevronRight } from "@mdi/js";
import Icon from "@mdi/react";
import AquiferSection from "./Sections/AquiferSection";
import { Helmet } from "react-helmet";
import { changeListViewTab } from '../../store';
import { useDispatch, useSelector } from "react-redux";

const array = [
  { title: "آبخوان", name: "Aquifer" },
  { title: "سد ها", name: "Dams" },
  { title: "ایستگاه هواشناسی", name: "WeatherStation" },
  { title: "ایستگاه سینوپتیک", name: "Synoptic" },
  { title: "ایستگاه هیدرومتریک", name: "Hydrometric" },
];

const ListView = () => {
  const tabSelected = useSelector(state => state.listviewtab)
  const [SelectedTab, setSelectedTab] = useState(array[tabSelected].name);
  const [Search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [notValidPage, setNotValidPage] = useState(false);
  const [pageRange, setPageRange] = useState(1);
  const dispatch = useDispatch()
  const url = {
    Dams: "dam-list",
    WeatherStation: "weather-list",
    Hydrometric: "hydrometric-list",
    Synoptic: "synoptic-list",
    Aquifer: "aquifer-list",
  };

  const getPageNumber = (len) => {
    setPageRange(len);
  };

  const notValidPageHandler = (e) => {
    setNotValidPage(e);
  };

  const handleSearch = (e) => {
    if (e.target.value) {
      setPage(1);
      setNotValidPage(false);
    }
    setSearch(e.target.value);
  };

  const handlePrevPage = (event) => {
    event.preventDefault();
    if (page > 1) {
      setPage((prev) => prev - 1);
    }
    if (notValidPage) {
      setNotValidPage(false);
    }
  };
  const handleNextPage = () => {
    setPage((prev) => prev + 1);
  };
  const titles = useMemo(() => {
    console.log(SelectedTab);
    setPage(1);
    setNotValidPage(false);
    // data from backend
    return array.map((e, index) => (
      <li
        style={{ margin: "auto" }}
        key={index.toString()}
        className={SelectedTab === e.name ? "selected" : ""}
        onClick={() => {
          setSelectedTab(e.name);
          setSearch("");
          dispatch(changeListViewTab(index))
        }}
      >
        {e.title}
      </li>
    ));
  }, [setSelectedTab, SelectedTab,dispatch]);

  return (
    <>
      <Helmet>
        <title>لیست داده ها</title>
      </Helmet>
      <Header />
      <div className="listTitles">
        <ul className="center responsiveCenter">{titles}</ul>
      </div>
      <div className="searchBar">
        <p>
          برای دسترسی سریعتر نام {SelectedTab === "Dams" ? "سد" : "ایستگاه"}{" "}
          موردنظر خود را جستجو کنید
        </p>
        <div className="searchBox">
          <input
            className="searchInput"
            type="text"
            value={Search}
            onChange={handleSearch}
            placeholder=":جستجو"
          />
        </div>
      </div>
      <div className="center">
        <div
          className="tabWrapper"
          style={{
            width: SelectedTab && `${types[SelectedTab].totalWidth + 330}px`,
          }}
        >
          <div className="tableBodyWrapper">
            {SelectedTab === "Aquifer" && (
              <AquiferSection
                getPageNumber={getPageNumber}
                page={page}
                setPageRange={setPageRange}
                notValidPageHandler={notValidPageHandler}
                link={url[SelectedTab]}
                Search={Search}
              />
            )}
            {SelectedTab === "Dams" && (
              <DamsSection
                getPageNumber={getPageNumber}
                page={page}
                setPageRange={setPageRange}
                notValidPageHandler={notValidPageHandler}
                link={url[SelectedTab]}
                Search={Search}
              />
            )}
            {SelectedTab === "WeatherStation" && (
              <WeatherStation
                getPageNumber={getPageNumber}
                page={page}
                setPageRange={setPageRange}
                notValidPageHandler={notValidPageHandler}
                link={url[SelectedTab]}
                Search={Search}
              />
            )}
            {SelectedTab === "Hydrometric" && (
              <HydrometricSection
                getPageNumber={getPageNumber}
                page={page}
                setPageRange={setPageRange}
                notValidPageHandler={notValidPageHandler}
                link={url[SelectedTab]}
                Search={Search}
              />
            )}
            {SelectedTab === "Synoptic" && (
              <SynopticSection
                getPageNumber={getPageNumber}
                page={page}
                setPageRange={setPageRange}
                notValidPageHandler={notValidPageHandler}
                link={url[SelectedTab]}
                Search={Search}
              />
            )}
          </div>
        </div>
        <div className="buttonConatiner">
          <button disabled={notValidPage} onClick={handleNextPage}>
            <Icon
              path={mdiChevronRight}
              size={1.5}
              horizontal
              vertical
              rotate={180}
              color={notValidPage ? "gray" : "#06846f"}
            />
          </button>
          <div className="rangeBox">
            <p>{pageRange}</p>
          </div>
          <div className="displayPageNumber--container">
            <p>صفحه {page}</p>
          </div>
          <div className="rangeBox">
            <p>1</p>
          </div>

          <button disabled={page === 1 && true} onClick={handlePrevPage}>
            <Icon
              path={mdiChevronRight}
              size={1.5}
              horizontal
              vertical
              rotate={0}
              color={page <= 1 ? "gray" : "#06846f"}
            />
          </button>
        </div>
      </div>

      <Footer />
    </>
  );
};
export default ListView;
